<template>
    <div class="">
        <ul class="row galery-list">
            <li class="col-6 col-md-3" v-for="(galery, index) in galeryImages">
                <img :src="galery['src']" :alt="galery['alt']" @click="setCurrentIndex(index)">
            </li>
        </ul>

        <transition v-if="showModal" name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">

                        <div class="prev-img arr">
                            <button class="btn" @click="previousImage"></button>
                        </div>
                        <div class="modal-body">
                            <img :src="currentImage['origin']" :alt="currentImage['alt']">
<!--                            <p class="title-img">{{currentImage['title']}}</p>-->
                        </div>
                        <div class="next-img arr">
                            <button class="btn" @click="nextImage"></button>
                        </div>
                            <button class="btn close-btn"
                                    @click="showModal = false">
                            </button>
                    </div>
                    <div class="modal-bg" @click="showModal = false"></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "galery-slider",
        components: {
            WidgetLoading,
        },
        props: {
            galeries: {
                required: true
            }
        },
        watch: {
            currentIndex: {
                handler() {
                    this.currentImage = this.galeryImages[this.currentIndex];
                },
                deep: true
            },
        },
        data() {
            return {
                currentImage: [],
                currentIndex: -1,
                showModal: false,
                galeryImages: [],
                Lang,
            }
        },
        methods: {
            setCurrentIndex(index) {
                this.currentIndex = index;
                this.showModal = true;
            },
            nextImage() {
                if (this.currentIndex >= this.galeryImages.length - 1) {
                    this.currentIndex = 0;
                }
                else {
                    this.currentIndex += 1;
                }
            },
            previousImage() {
                if (this.currentIndex <= 0) {
                    this.currentIndex = this.galeryImages.length - 1;
                }
                else {
                    this.currentIndex -= 1;
                }
            },
        },
        mounted() {
            this.galeryImages = this.galeries;
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/GalerySlider.vue